import { render, staticRenderFns } from "./AddDocumentModalComponent.vue?vue&type=template&id=7c89b42a"
import script from "./AddDocumentModalComponent.vue?vue&type=script&lang=ts"
export * from "./AddDocumentModalComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c89b42a')) {
      api.createRecord('7c89b42a', component.options)
    } else {
      api.reload('7c89b42a', component.options)
    }
    module.hot.accept("./AddDocumentModalComponent.vue?vue&type=template&id=7c89b42a", function () {
      api.rerender('7c89b42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/PackageDocument/Components/AddDocumentModalComponent.vue"
export default component.exports